import { Document } from 'src/app/modules/core/store/models/document.model';
import { SafeUrl } from '@angular/platform-browser';

export interface Timeline extends Document {
}

export interface TimelineDisplay extends Timeline {
  displayIcon: string;
  typeString: string;
  isInterview: boolean;
  displayDesc: string;
  hasDescMoreLess: boolean;
  descMoreLess: string;
  displayDate: string;
}

export interface UploadedMedia {
  timelineId: string;
  fileName: string;
  fileUrl: SafeUrl;
  expiresOn: Date;
}

export const TimelineUpdateType = '8f218ac7-2443-401b-9b54-dabdd06bc878';
export const TimelineFindingType = '5f2450f8-707b-4e6c-937b-92f53e20c5aa';
export const TimelineInterviewType = '8e66402b-9513-421a-8610-70ed1ff889ba';
export const TimelinePhotoType = 'ba61645c-4e76-40c8-9801-a02229828440';
export const TimelineVideoType = '509b8945-c108-49e1-ac34-9e9c7d98aaeb';
export const TimelineDocumentType = '68e651c9-1927-4e52-8df5-d67f78370de3';
export const TimelineLinkType = '612dbfc5-7c23-486a-8b68-f054d40669b2';

export const TimelineTypeMap: Map<string, any> = new Map<string, any>([
  [null, { select: false, icon: "assets/images/orange_briefcase.svg", name: "Initial Report" }],
  [TimelineUpdateType, { select: true, icon: "assets/images/comment.svg", name: "Update" }],
  [TimelinePhotoType, { select: true, icon: "assets/images/orange_image.svg", name: "Photo" }],
  [TimelineVideoType, { select: true, icon: "assets/images/orange_video.svg", name: "Video" }],
  [TimelineDocumentType, { select: true, icon: "assets/images/orange_document.svg", name: "Document" }],
  [TimelineInterviewType, { select: false, icon: "assets/images/orange_microphone.svg", name: "Interview" }],
  [TimelineLinkType, { select: true, icon: "assets/images/orange_link.svg", name: "Link" }],
]);


